if (!customElements.get('gift-wrap-option')) {
  class GiftWrapOption extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.input = this.querySelector('.gift-wrap-option__checkbox');
      this.status = this.querySelector('.gift-wrap-option__status');
      this.variantId = Number(this.dataset.variantId);
      this._onChange = this.onChange.bind(this);
      this.input?.addEventListener('change', this._onChange);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('change', this._onChange);
    }

    async request(url, options = {}) {
      const response = await fetch(url, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(options.headers || {})
        }
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(`Gift wrap cart update failed (${response.status}): ${body.description || body.message || JSON.stringify(body)}`);
      }

      return response.json();
    }

    setBusy(isBusy) {
      this.toggleAttribute('aria-busy', isBusy);
      if (this.input) this.input.disabled = isBusy;
    }

    async onChange() {
      const shouldAdd = this.input.checked;
      this.setBusy(true);
      this.status.textContent = shouldAdd ? 'Ajout en cours…' : 'Retrait en cours…';

      try {
        const cart = await this.request(`${theme.routes.cart_url}.js`);
        const giftWrapItems = cart.items.filter((item) => item.variant_id === this.variantId);

        if (shouldAdd && giftWrapItems.length === 0) {
          await this.request(`${theme.routes.cart_add_url}.js`, {
            method: 'POST',
            body: JSON.stringify({
              items: [{ id: this.variantId, quantity: 1 }]
            })
          });
        } else if (!shouldAdd && giftWrapItems.length > 0) {
          const updates = {};
          giftWrapItems.forEach((item) => {
            updates[item.key] = 0;
          });

          await this.request(`${theme.routes.cart_update_url}.js`, {
            method: 'POST',
            body: JSON.stringify({ updates })
          });
        }

        this.status.textContent = '';
        this.setBusy(false);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        this.input.checked = !shouldAdd;
        this.status.textContent = 'La mise à jour a échoué. Veuillez réessayer.';
        this.setBusy(false);
        console.error(error);
      }
    }
  }

  customElements.define('gift-wrap-option', GiftWrapOption);
}
